import { createBrowserHistory } from 'history';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import React, { useMemo } from 'react';
import { Router } from 'react-router-dom';
import { ReactRouterHistoryContext } from './common/v2/context/contexts';

export const RoutesWrapper = (props: { children: React.ReactNode }) => {
  const browserHistory = useMemo(() => createBrowserHistory(), []);
  const routingStore = useMemo(() => new RouterStore(), []);
  const history = useMemo(
    () => syncHistoryWithStore(browserHistory, routingStore),
    [browserHistory, routingStore]
  );

  return (
    <Router history={history}>
      <ReactRouterHistoryContext.Provider value={history}>
        {props.children}
      </ReactRouterHistoryContext.Provider>
    </Router>
  );
};
